<template lang="pug">
article
  //-
  //- Hero section
  //-
  section.hero
    BackgroundImage(
      src="/images/backg_portada.jpg"
      alt="Portfolio Stock Exchange"
      loading="eager")
      .hero__container
        h1.hero__title
          | Reinventando los Mercados de Capitales
          .gradient tal y como deberían ser


        h2.hero__subtitle
          | La Bolsa Europea de nueva generación. Para empresas e inversores de todos los tamaños a nivel mundial.

        .hero__actions
          NuxtLink.button(
            to="https://app.portfolio.exchange"
            target="_blank"
            external
            aria-label="Acceder a Portfolio Stock Exchange") Acceder

          NuxtLinkLocale.link(to="/#video" aria-label="Learn more about our vision and platform")
            | Descubre cómo funciona Portfolio Stock Exchange
            svg(
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor")
                path(
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3")

  //-
  //- Partnes carousel
  //-
  section
    Carousel(title="Partners de confianza")

  //-
  //- Authorization banner
  //-
  section
    .banner
      .banner__wrapper Portfolio Stock Exchange es un sistema multilateral de negociación sujeto a la normativa de la Unión Europea. Estamos autorizados por la Comisión Nacional del Mercado de Valores (CNMV).

  //-
  //- Video section
  //-
  section(id="video")
    BackgroundImage(
      src="/images/bck_moneym.jpg"
      alt="Fondo mercado monetario"
      loading="eager"
      wrapper-class="section__background")
      .section__header.margin-bottom-double
        .section__header__cto Todo lo que necesita saber
        h2.section__header__title Portfolio explicado en solo 3 min.

      Vimeo(
        video-id="716058085"
        title="Portfolio explicado en solo 3 min"
      )

  //-
  //- Responsive Capital Markets
  //-
  section
    BackgroundImage(
      src="/images/back_responsive_n.jpg"
      alt="Fondo Mercados de Capitales flexibles"
      loading="lazy"
      wrapper-class="section__background")
      .section__header.section__header--left
        .section__header__cto Portfolio Stock Exchange
        h2.section__header__title Mercados de Capitales flexibles
        .section__header__subtitle
          | Portfolio es la primera bolsa del mundo que ofrece un mercado primario y secundario en la misma plataforma, integrando los procesos de custodia y post-contratación para todo tipo de emisores e inversores,
          span.strong.gradient.margin-left-quarter consiguiendo ahorros para nuestros clientes de hasta el 90% de los costes globales
          | .

      .section__body
        p Un Sistema Multilateral de Negociación (SMN) abierto y accesible para acciones, bonos, fondos y pagarés

        p
          | Para Socimis.
          br
          | Para empresas Mid Cap y tecnológicas.
          br
          | Para industriales y FMCG.
          br
          | Para empresas familiares.
          br
          | Para Project Finance.
          br
          | Para e-sports.
          br
          | Para plataformas de crowdfunding de Equity y Deuda.
          br
          | Para bonos.
          br
          | Para fondos de Capital Riesgo.
          br
          | Para fondos de inversión alternativa.
          br
          | Para otros vehículos de inversión.

        p.strong.gradient Portfolio, la bolsa de valores para empresas ambiciosas, sea cual sea su tamaño o su país de origen.

  //-
  //- New stock exchange, New possibilities
  //-
  section.margin-bottom-quadruple
    Parallax(background="/images/bck_row9.jpg")
      h2
        | Nueva bolsa,
        br
        | Nuevas posibilidades

  //-
  //- Portfolio's secret sauce
  //-
  section
    .section__header.section__header--left
      .section__header__cto El modelo de negocio de las bolsas tradicionales está obsoleto.
      h2.section__header__title La salsa secreta de Portfolio
      .section__header__subtitle Nuestras innovaciones tecnológicas y legales nos permiten ser la primera bolsa de valores que da prioridad a las necesidades de los clientes en cuanto a acceso, seguridad, privacidad y control, al tiempo que agiliza los procesos para ofrecer un ahorro de tiempo y costes sin precedentes.

    .section__body
      p Portfolio es un sistema rediseñado de principio a fin para acciones, bonos, fondos de inversión y pagarés, con un proceso de emisión optimizado y que facilita la gestión de todo el ciclo de vida de su instrumento financiero.
      p
        span.strong.gradient.margin-right-quarter Eliminamos 14 intermediarios tradicionales ahorrando hasta un 90% del coste total
        | y ofrecemos acceso a inversores de todos los tamaños, incluidos minoristas.

  ClientOnly
    Infographic.padding-top-quadruple.padding-bottom-quadruple
    template(#fallback)
      .infographic-loader(style="height: 600px; display: flex; align-items: center; justify-content: center;")
        Loader

  //-
  //- Access to the market to investors of all sizes
  //-
  section.margin-bottom-quadruple
    Parallax(background="/images/bck_row2.jpg")
      h2
        | Acceso a mercado a inversores
        br
        | de todos los tamaños

  //-
  //- 12+1 Portfolio's main advantages
  //-
  section.margin-bottom-quadruple
    .section__header
      .section__header__cto Portfolio Stock Exchange
      h2.section__header__title 12+1 Principales ventajas de Portfolio
      .section__header__subtitle Aquí tiene un breve resumen de los beneficios que puede obtener con Portfolio.

    AdvantagesTable

  //-
  //- Let's bring the digital era to Capital Markets
  //-
  section.margin-bottom-quadruple
    Parallax(background="/images/bck_row1.jpg")
      h2
        | Llevemos la era digital
        br
        | a los Mercados de Capitales

  //-
  //- Portfolio's features
  //-
  section.margin-bottom-quadruple
    .features
      dl.features__list
        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_funding.svg"
                alt="Financiación")
            | Financiación
          dd Capte financiación a través de una salida a bolsa, una emisión de deuda o vía fusión con una SPAC.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_target.svg"
                alt="Diríjase a los inversores")
            | Diríjase a los inversores
          dd Diríjase a inversores institucionales, profesionales o minoristas directamente a través de nuestra plataforma o del marketing digital.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_tailor.svg"
                alt="Emisiones a medida")
            | Emisiones a medida
          dd En Portfolio pensamos que los Mercados de Capitales deben reinventarse así que queremos hacerlo permitiendo a nuestros clientes que construyan ese futuro.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_syndicate.svg"
                alt="Sindicación sencilla")
            | Sindicación sencilla
          dd Proceso de sindicación de inversores digitalizado.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_engange.svg"
                alt="Involucre a sus clientes")
            | Involucre a sus clientes
          dd Permita que sus clientes o seguidores inviertan directamente en su empresa para que formen parte de su crecimiento.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_restriction.svg"
                alt="Restricciones a los accionistas")
            | Restricciones a los accionistas
          dd Configure requisitos de aprobación para compras-ventas o establece restricciones en derechos de voto.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_onboarding.svg"
                alt="Onboarding digital")
            | Onboarding digital
          dd Reciba a sus inversores con un proceso de registro digital simplificado y totalmente online.

        .feature
          dt
            .feature__icon
              img(
                src="/icons/ico_save.svg"
                alt="Ahorre tiempo y dinero")
            | Ahorre tiempo y dinero
          dd Realice su proceso de emisión más rápidamente, ahorrando hasta un 90% de los costes totales.

  //-
  //- A stock exchange should be an enabler, not an obstacle
  //-
  section.margin-bottom-double
    Parallax(background="/images/bck_row3.jpg")
      h2
        | Una bolsa de valores debe ser un catalizador,
        br
        | no un obstáculo

  //-
  //- Investors section
  //-
  section
    BackgroundImage(
      src="/images/back_investors_n.jpg"
      alt="Fondo inversores"
      loading="lazy"
      wrapper-class="section__background")
      .section__header.section__header--left
        .section__header__cto Portfolio Stock Exchange
        h2.section__header__title Inversores
        .section__header__subtitle Portfolio permite a cada inversor institucional, profesional, asesor financiero, family office e incluso inversor minorista operar directamente a través de nuestra plataforma web o aplicación móvil.

      .section__body
        h3.no-margin-bottom Acceso al mercado
        p Directamente a través de nuestra plataforma. No se necesita ningún miembro ni broker.

        h3.no-margin-bottom KYC/KYB + Cuenta de valores
        p Esté preparado para invertir en pocos minutos con nuestro sencillo proceso de onboarding digital, tanto para empresas como para particulares. En menos de 5 minutos abrimos su cuenta de valores para empezar a operar al instante.

        h3.no-margin-bottom Custodia
        p Evite costes adicionales. Nosotros custodiamos sus fondos e instrumentos financieros.

        .layout--center
          NuxtLinkLocale.button(to="/portfolio-investors") Saber más
</template>

<script setup lang="ts">
  // Lazy load Infographic component (includes GSAP ~120 KB)

  //
  // Data
  //

  const Infographic = defineAsyncComponent(() => import('~/components/Infographic.vue'))
  definePageMeta({
    title: 'pages.home.title',
    description: 'pages.home.description',
    i18n: {
      locales: ['es'],
      paths: {
        es: '/',
      },
    },
  })
</script>
